module.exports = __webpack_public_path__ + "assets/images/red2_b945ec4441032c2c81ebbb0565250f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/red2.png
// module id = 156
// module chunks = 0